const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "8,52 50,10 92,52",
    fill: "none",
    stroke: "#151413",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "none",
      stroke: "rgb(21, 20, 19)",
      color: "rgb(251, 251, 254)",
      strokeWidth: "4.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 46,
    x2: 18,
    y2: 90,
    stroke: "#151413",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(21, 20, 19)",
      color: "rgb(251, 251, 254)",
      strokeWidth: "4.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 46,
    x2: 82,
    y2: 90,
    stroke: "#151413",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(21, 20, 19)",
      color: "rgb(251, 251, 254)",
      strokeWidth: "4.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 90,
    x2: 82,
    y2: 90,
    stroke: "#151413",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(21, 20, 19)",
      color: "rgb(251, 251, 254)",
      strokeWidth: "4.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 64,
    width: 24,
    height: 26,
    rx: 2,
    fill: "none",
    stroke: "#151413",
    strokeWidth: 4,
    style: {
      fill: "none",
      stroke: "rgb(21, 20, 19)",
      color: "rgb(251, 251, 254)",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconV2);
export default __webpack_public_path__ + "static/media/home_icon_v2.3ad8fb72366108fda27e9356c06b25dc.svg";
export { ForwardRef as ReactComponent };